import { Injectable, inject } from "@angular/core";
import { ResolveFn } from "@angular/router";
import { ALLOW_REGISTRATION, APIM_SUB_KEY, API_BASE_URL, APP_COPYRIGHT } from "@vp/shared/tokens";
import { Observable, of } from "rxjs";

@Injectable()
export class AppSettingsResolverService {
  private allowRegistration = inject(ALLOW_REGISTRATION);
  private appCopyright = inject(APP_COPYRIGHT);
  private baseApi = inject(API_BASE_URL);
  private apimSubscriptionKey = inject(APIM_SUB_KEY);

  resolve(): Observable<appSettings> {
    return of({
      allowRegistration: this.allowRegistration,
      appCopyright: this.appCopyright,
      baseApi: this.baseApi,
      apimSubscriptionKey: this.apimSubscriptionKey
    } as appSettings);
  }
}

export interface appSettings {
  allowRegistration: boolean;
  appCopyright: string;
  baseApi: string;
  apimSubscriptionKey: string;
  appInsightsKey: string;
  ambraViewerBaseUrl: string;
  deviceLoginSuffix: string;
  authServer: string;
  oktaClientId: string;
  consumerOktaEnv: string;
  oktaLoginBrand: string;
  functionStorageAccountName: string;
}

export const AppSettingsResolver: ResolveFn<appSettings> = (): Observable<appSettings> => {
  return inject(AppSettingsResolverService).resolve();
};
